import {rootReducer} from '../reducers';
import {connect as reduxConnect} from 'react-redux';
import {lookup} from 'ereader-core/dist/utils.main.js';

let SCOPE_CHAIN = '';

export function connect(mapStateToProps, actions){
    const getState = mapStateToProps ? function(state){
        if (!SCOPE_CHAIN) return mapStateToProps(state);

        return mapStateToProps(lookup(state, SCOPE_CHAIN));
    } : null;

    return reduxConnect(getState, actions);
}

export function getComposedReducer(scope_chain){
    SCOPE_CHAIN = scope_chain || '';
    return rootReducer;
}

export function getInState(getState, path, def){
    if (SCOPE_CHAIN) path = `${SCOPE_CHAIN}.${path}`;
    return lookup(getState(), path, def);
}


// WEBPACK FOOTER //
// ./src/helpers/composeReducer.js